class Auth {
  static storeToken(token) {
    sessionStorage.setItem('token', token);
  }

  static storeIdToken(id_token) {
    sessionStorage.setItem('id_token', id_token);
  }

  static retrieveToken() {
    return sessionStorage.getItem('token');
  }

  static retrieveIdToken() {
    return sessionStorage.getItem('id_token');
  }

  static setUserActive(active = false) {
    sessionStorage.setItem('user_active', active);
  }

  static isUserActive() {
    return sessionStorage.getItem('user_active');
  }

  static logout() {
    sessionStorage.clear();
  }

  static isAuthorized() {
    return this.retrieveToken() && this.isUserActive();
  }

  static hasPrivilege() {
    return this.retrieveToken();
  }
}

export default Auth;
